module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bRTXO"))).then(() => parcelRequire('fThBo'));